
export default {
    inserted: (el, { value }) => value && el.focus()
}